import React, { useEffect, useState } from 'react';
import styles from './CookieChecker.module.scss';
import { getConfig } from '../Config/ApplicationConfig';

const checkForCookie = async () => {
    const cookieFrame = document.createElement('iframe');
    cookieFrame.src = `${getConfig().cookieCheck.url}start.html`;
    cookieFrame.classList.add(styles.hiddenIFrame);

    document.body.appendChild(cookieFrame);

    return () => {
        document.body.removeChild(cookieFrame);
    };
};

export enum CookieStatus {
    Checking = 'Checking',
    Safe = 'Safe',
    TimedOut = 'TimedOut',
    Unsafe = 'Unsafe'
}

const isDevelopmentMode = process.env.NODE_ENV === 'development';

console.log(`Application is running in ${isDevelopmentMode ? 'Dev' : 'Prod'} mode`);

export function useCookieChecker() {
    const [cookieStatus, setCookieStatus] = useState(CookieStatus.Checking);

    useEffect(() => {
        if (isDevelopmentMode) {
            // If the app is in development mode, just skip out on cookie checking
            setCookieStatus(CookieStatus.Safe);
            return;
        }

        const failedToLoadIFrame = () => {
            setCookieStatus(CookieStatus.TimedOut);
        };

        const serviceTimeout = setTimeout(failedToLoadIFrame, 10000);

        const windowMessageRecieved = (evt: any) => {
            if (evt.data === 'MM:3PCunsupported') {
                if (serviceTimeout) clearTimeout(serviceTimeout);

                setCookieStatus(CookieStatus.Unsafe);
            } else if (evt.data === 'MM:3PCsupported') {
                if (serviceTimeout) clearTimeout(serviceTimeout);

                setCookieStatus(CookieStatus.Safe);
            }
        };

        window.addEventListener('message', windowMessageRecieved, false);
        checkForCookie();

        return () => {
            if (serviceTimeout) clearTimeout(serviceTimeout);

            window.removeEventListener('message', windowMessageRecieved, false);
        };
    }, []);

    return {
        cookieStatus
    };
}
